export { default as defaultStartNames } from '@/components/nodes/baseStartEvent/defaultNames';
export { default as defaultEndNames } from '@/components/nodes/endEvent/defaultNames';
export { default as defaultTaskNames } from '@/components/nodes/task/defaultNames';
export { default as defaultGatewayNames } from '@/components/nodes/gateway/defaultNames';
export { default as defaultIntermediateNames } from '@/components/nodes/intermediateEvent/defaultNames';
